// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".builderCanvas--2XYeRzoN {\n  position: relative;\n  flex: auto;\n  min-height: 0;\n  margin: var(--page-card-gap) 0 0 var(--page-card-gap);\n}\n\n.fullscreen--1Mb5bCOT {\n  margin: var(--page-card-gap);\n}\n\n.hasTabs--1bMFggNf {\n  margin-top: calc(var(--page-card-gap) + 10px);\n}\n\n.builderCanvasInner--1_HIY8Mn {\n  position: relative;\n  background-color: #fff;\n  color: rgba(0, 0, 0, 0.85);\n  border-radius: var(--editor-brick-border-radius);\n  height: 100%;\n}\n\n.builderCanvasInner--1_HIY8Mn > .ant-card > .ant-card-body {\n  padding: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"builderCanvas": "builderCanvas--2XYeRzoN",
	"fullscreen": "fullscreen--1Mb5bCOT",
	"hasTabs": "hasTabs--1bMFggNf",
	"builderCanvasInner": "builderCanvasInner--1_HIY8Mn"
};
export default ___CSS_LOADER_EXPORT___;
